import { UseQueryOptions, useQuery } from 'react-query'

import { IndexResponse, PaginationQueryParam, WhereQueryParam, reqListings } from '@/api/api-nika'
import cateGraphQLClient from '@/graphql/cate/client'
import { PotentialPropertyByFilterQuery } from '@/types/cate-graphql-generated-types'
import { Listing } from '@/types/nika'
import { SortOptions } from '@/types/sort'
import { legacyFiltersToNikaFilters, legacySortingToNikaSorting } from '@/utils/nika/query-mapper'

import { PAGINATION_SIZE } from '../listingsByFilter/helpers'

import { getPriorityGroupBy, getPriorityWhereCondition } from './utils'

function buildQueryKeyForIndex(
  name: string,
  sort_by: SortOptions,
  filters?: WhereQueryParam,
  pagination?: PaginationQueryParam,
  paginationPriority?: PaginationQueryParam
) {
  return [
    name,
    `${sort_by.by}-${sort_by.direction}`,
    pagination ? pagination.page_size : '20',
    pagination ? pagination.page : '1',
    paginationPriority ? paginationPriority.page_size : '20',
    paginationPriority ? paginationPriority.page : '1',
    filters ? JSON.stringify(filters) : '{}',
  ]
}

export type UseListingsResponse = {
  listings: IndexResponse<Listing>
  priorities: PotentialPropertyByFilterQuery | undefined
}

export const useListings = (
  sortBy: SortOptions,
  filters?: WhereQueryParam,
  pagination?: PaginationQueryParam,
  paginationPriority?: PaginationQueryParam,
  options?: UseQueryOptions<UseListingsResponse>
) => {
  const key = buildQueryKeyForIndex('listingPriority-index', sortBy, filters, pagination, paginationPriority)
  return useQuery(
    key,
    () => {
      return Promise.all([
        reqListings(legacyFiltersToNikaFilters(filters), pagination, legacySortingToNikaSorting(sortBy)),
        fetchPriorities(filters, sortBy, paginationPriority, PAGINATION_SIZE),
      ])
        .then(([resListing, potential_property]) => {
          return { listings: resListing.data, priorities: potential_property?.data }
        })
        .catch()
    },
    options
  )
}

const fetchPriorities = async (
  filters: WhereQueryParam,
  sort: SortOptions,
  { page, page_size }: PaginationQueryParam,
  limit: number
) => {
  const offset = page === 1 ? 0 : (page - 1) * page_size
  return await cateGraphQLClient.potentialPropertyByFilter({
    limit,
    offset,
    orderBy: getPriorityGroupBy(sort),
    where: getPriorityWhereCondition(filters),
  })
}
